const isMacPlatform = () => {
  if (typeof navigator === 'undefined') {
    return false
  }

  const platform =
    (navigator as any).userAgentData?.platform ??
    navigator.platform ??
    navigator.userAgent

  return /mac|iphone|ipad|ipod/i.test(platform)
}

type ShortcutOptions = {
  forceControl?: boolean
  includeShift?: boolean
}

export const getPlatformShortcutKeys = (
  key: string,
  options?: ShortcutOptions,
): Array<string> => {
  const normalizedKey = key.trim().toUpperCase()
  if (!normalizedKey) {
    return []
  }

  const keys: Array<string> = []
  const modifierKey =
    options?.forceControl || !isMacPlatform() ? 'Ctrl' : '⌘'
  keys.push(modifierKey)

  if (options?.includeShift) {
    keys.push('Shift')
  }

  keys.push(normalizedKey)
  return keys
}
